import { useEffect } from "react";
import { useContext } from "react";
import { useMutation } from "react-query";
import AppContext from "./appContext";

import * as api from "./services";
import { logging } from "./tools";

export default function useLockMutation() {
  const {
    app: {
      client: { id: clientId },
      sessionId,
    },
  } = useContext(AppContext);


  const lockmutation = useMutation(
    () => api.postLock({ clientId, sessionId }),
    {
      onMutate: () => logging("LOCK CLIENT " + clientId),
    }
  );
  return lockmutation;
}
